<template>
    <div class="input-keyword-specs">
        <b-input-group>
            <b-input v-model="currentKeyword.keyword"/>
            <b-input-group-text>min</b-input-group-text>
            <e-input type="number" v-model="currentKeyword.min" style="max-width: 60px" state="disabled"/>
            <b-input-group-text>max</b-input-group-text>
            <e-input type="number" v-model="currentKeyword.max" style="max-width: 60px" state="disabled"/>
            <b-btn variant="outline-white" @click="$emit(`remove`)"><i class="fas fa-close"/></b-btn>
        </b-input-group>
        <div class="form-control" v-if="currentKeyword.variations && showVariations">
            <i class="fas fa-arrow-turn-down-right mr-1"/>
            <b-badge class="mb-1 mr-1" variant="light" v-for="(variation, index) in currentKeyword.variations" :key="`${currentKeyword.keyword}-${index}`">
                {{variation}}
            </b-badge>
        </div>
    </div>
</template>

<script>
import EInput from "../../../../../vue-components/components/e-input.vue";

export default {
    name: `input-keyword-specs`,
    components: {EInput},
    props: {
        value: {type: Object, required: true},
        showVariations: {type: Boolean}
    },
    computed: {
        currentKeyword: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit(`input`, value);
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.input-keyword-specs {
    .input-group,
    .form-control {
        border-radius: 0 !important;
    }

    > .form-control {
        margin-top: -1px;
        height: auto;
    }

    &:not(:first-child) {
        .input-group {
            margin-top: -1px;
        }
    }
    //&:not(:last-child) {
    //    :last-child {
    //        border-bottom-left-radius: 0 !important;
    //        border-bottom-right-radius: 0 !important;
    //    }
    //}

    .form-control {
        border-bottom-color: var(--border-color) !important;
    }
}
</style>
